module.exports = __webpack_public_path__ + "img/prestashop.15af3f65.png";